module.exports = __webpack_public_path__ + "static/cashIcon-b96cff586dcab4a3f52635972a68cda5.png";